<template>
  <div class="login-overlay">
      <div class="login--overlay-container " :class="open && 'show-slow'">

          <div class="app-overlay-close" v-on:click="$emit('closeLoginOverlay')">&times;</div>

        <div class="login-container-columns">
          <div class="login-container-column">
            <h3>köhler. klinker app</h3>
<!--             <p>Loggen Sie sich direkt einfach mit einem der bekannten Services ein oder in Ihren bestehenden Account mit Mail-Adresse und Passwort.</p> -->
          </div>
        </div>
        <div class="login-container-columns">
          <div class="login-container-column">
            <p>Bitte loggen Sie sich ein, um Ihre Projekte und Favoriten zu speichern und  zu verwalten.</p>
            <h3>Sie haben noch keinen Account?</h3>
            <p>Die Klinker App bietet Ihnen mehr. Und das kostenlos.<br><a v-on:click="goToSighUp" href="#!">Jetzt Account anlegen</a></p>
<!--
              <pwa-auth 
              v-on:signinCompleted="signinCompleted"
              appearance="list"
              applekey="00000"
              microsoftkey="000000"
              googlekey="00000"
              facebookkey="00000"
              
            ></pwa-auth>
-->
    
          </div>
          <div class="login-container-column">
            
            <form class="form" @submit.prevent="handleSubmit">
               <input type="email" name="username" v-model="username" placeholder="E-Mail" :class="{ 'is-invalid': submitted && !username }">
               <div v-show="submitted && !username" class="invalid-feedback">Bitte E-Mail-Adresse eingeben</div>
               <br>
               <input type="password" name="password" v-model="password" placeholder="Passwort" :class="{ 'is-invalid': submitted && !password }">
               <div v-show="submitted && !password" class="invalid-feedback">Bitte Passwort eingeben</div>
               <br><br>
               <button v-show="!loggingIn" type="submit" :disabled="loggingIn">Einloggen</button>
               <img v-show="loggingIn" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            </form>
    
            
    
          </div>
        </div>



      </div>
  </div>
</template>
<script>
  export default {
    name: 'LoginOverlay',
    data () {
        return {
            username: '',
            password: '',
            submitted: false,
            open: false,
        }
    },
    computed: {
        loggingIn () {
            return this.$store.state.authentication.status.loggingIn;
        }
    },
    created () {
      console.log(
        'login layer created'
      );
      setTimeout(()=>{ this.open = true; }, 300)
      
        // reset login status
        //this.$store.dispatch('authentication/logout');
    },

    methods: {
      
        goToSighUp(e){
          e.preventDefault();
          this.$router.push({ name: 'SignUp'})
        },
      
        signinCompleted(e){
          console.log( 'Login via Social Service');
        },
      
        scrtnxtsctn() {
          $('html,body').animate({ scrollTop: $('#home_content').position().top },800);
        },

        handleSubmit (e) {
            //this.submitted = true;
            //console.log( this.originalRoute );
            var to = null //this.originalRoute || 'Home';  //"/"; //this.$route.params.r ? "/"+this.$route.params.r : "/"
            //console.log( to )
            //to = to == "Login" || "Home"
            const { username, password } = this;
            const { dispatch } = this.$store;
            if (username && password) {
                dispatch('authentication/login', { username, password, to });
            }
        }
    }

  }
</script>
<style scoped>
  .login-overlay { background: rgba(50,50,50,0.7); position: fixed; z-index: 100001; top: 0; left: 0; right: 0; bottom: 0; display: flex; justify-content: center; align-items: center; }
 
  .login--overlay-container { max-width: 40em; padding-bottom: 3em; margin: 0 1.23333em; background: rgba(0,0,0,0.95); padding: 0 0.9333em; border-radius: 3px;  transform:translateY(0em); 
    opacity: 0; transition: opacity 0.6s ease;
    }
  .show-slow { opacity: 1; }
 
 .login-container-column { padding: 0.93333em 1.433333em; }

 .login-container-columns:last-child { padding: 0 0 1.83333em 0; }
 
  @media screen and ( min-width: 768px) {
    .login-container-columns { display: flex; align-items: flex-start; }
    .login-container-columns:last-child { padding: 0 0 1.83333em 0; }
    .login-container-column p { padding: 0; margin: 0 0 0.93333em 0; }
    .login-container-column p:last-child { margin: 0 0 0 0; }
    .login-container-columns:last-child .login-container-column:first-child { border-right: 1px solid #fff; }
  }

  .error { border: 1px solid #dc1200; padding: 0.6333333em; margin: 0 0 0.9333333em 0; background: rgba(245, 17, 17, 0.12) }
  .close { text-decoration: none; color: #dc1200; font-size: bold;}

  img { display: block; max-width: 100%; }
  .login-container img { max-width: 10em; margin: 0 auto 0.9333333em; }
  input { border: 1px solid #343434; border-radius: 3px; padding: 0.4333333em 0.9333333em; margin-bottom: 0.33333em; outline: 0; transition: border-color 0.2s; font-size: 1.2rem; }
  input:focus { border-color: #000; }

  
  
  
</style>